import { JObject } from "../../../../../common/data/models";
import { StoreProductQuantityLimitation } from "../models";


export const StoreProductQuantityLimitationMapper = {
    /**
     * Create quantity limitation model from json object
     * @param json
     * @returns {StoreProductQuantityLimitation}
     */
    fromJson: (json?: JObject): StoreProductQuantityLimitation => {
        return {
            classificationId: json?.classificationId,
            classification: json?.classification,
            customer: json?.customerId ? {
                partnerId: json?.customerId,
                partnerName: json?.customerName
            } : undefined,
            langCode: json?.langCode,
            quantity: json?.quantity,
            siteId: json?.siteId,
            store: {
                partnerId: json?.storeId,
                partnerName: json?.storeName
            },
            storeProduct: {
                storeProductId:json?.storeProductId,
                titleAr: json?.titleAr,
                titleEn: json?.titleEn
            },
            storeProductQuantityLimitationId: json?.storeProductQuantityLimitationId,
            priceListId: json?.priceListId,
            priceListName: json?.priceListName
        }
    },

    /**
     *
     */
    toJson: (model: StoreProductQuantityLimitation): JObject => {
        return {
            quantity: model.quantity,
            customerId: model.customer ? model.customer!.partnerId: undefined,
            storeProductQuantityLimitationId: model.storeProductQuantityLimitationId,
            storeProductId: model.storeProduct?.storeProductId,
            classificationId: model.classificationId,
            priceListId: model.priceListId
        };
    },
}

